import _ from "lodash";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPostList, getPostListResponseClear } from "../../redux/myNetwork/actions";
import { SessionKeys } from "../../utils/AppUtils";
import PostList from "../myNetwork/PostList";
import UploadPostContent from "../myNetwork/UploadPostContent";

const MyWall = (props) => {

    const { fromPage, setIsLoading, fetchData } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    var postListRes = useSelector((state) => state.myNetwork.postListRes);
    const authBroker = useSelector((state) => state.auth.authBroker)

    const [postList, setPostList] = useState([]);
    const [hasMore, setHasMore] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [pageNumber, setPageNumber] = useState(0)

    useEffect(() => {
        // window.scrollTo(0, 0);
        setPostList([])
        setPageNumber(1)
        return (() => {
            dispatch(getPostListResponseClear());
        })
    }, [])

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            if (authBroker.payload.user.role.includes('guest')) {
                navigate('/home')
            }
        }
    }, [authBroker])

    var pageNo = 1;
    useEffect(() => {
        console.log('postListRes: ', postListRes)
        if (!_.isEmpty(postListRes)) {
            setIsLoad(false);

            if (postListRes?.status === "success") {

                let dataRes = postListRes?.payload?.payload;
                dispatch(getPostListResponseClear());
                let postListR = dataRes?.activity_data;

                for (const item of postListR) {
                    item.localComment = '';
                    item.isShowCmntView = true;
                    item.cmntCount = 1;
                }

                setHasMore(dataRes?.next_tab)

                if (pageNumber > 1) {
                    let PostList = _.cloneDeep(postList);
                    setPostList(PostList.concat(postListR));
                } else {
                    setPostList(postListR);
                }

            }
        }
    }, [postListRes]);

    useEffect(() => {
        if (pageNumber > 0 && fetchData) {
            getActivityPostList();
        }
    }, [pageNumber, fetchData])





    const getActivityPostList = () => {
        console.log('getActivity-call;;;;1')
        setIsLoad(true);
        dispatch(
            getPostList({
                module: "getPostList",
                postData: {
                    token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    page: pageNumber,
                    page_size: "4"
                },
            })
        );
    };

    return (
        <>
            <section className={fromPage === 'myWall' ? "my-wall-section-rsp" : "my-wall-section-rsp with-home-community"}>
                <div className={fromPage === 'myWall' ? "container" : ""}>
                    <div className="row">
                        <div className="col-md-12 mt-1">
                            <div >
                                <div className="d-flex My_Dashboardwall My_Dashboard">
                                    <h3 id="idMyWall" className="mb-4">My Wall</h3>
                                    {fromPage === 'home' ? <a>
                                        <button className="button-reset mywallarrow" onClick={() => { navigate('/my-wall') }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="30"
                                            height="30"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                        >
                                            <path
                                            d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                                            stroke="#6941C6"
                                            strokeWidth="1.66667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            ></path>
                                        </svg>
                                            
                                        </button>
                                    </a> : ""}
                                </div>

                                {<UploadPostContent setIsLoading={setIsLoading} setPostList={setPostList} postList={postList} getActivityPostList={getActivityPostList} />}
                            </div>
                            {isLoad && pageNumber < 2 ? (
                                <div className="pt-5 loader-launch">
                                    {[...Array(4)].map((el, index) => (
                                        <ContentLoader key={index} className="pt-2 w-100" />
                                    ))}
                                </div>
                            ) : <PostList postList={(fromPage === 'home' && postList.length > 0) ? postList : postList} setPostList={setPostList} getActivityPostList={getActivityPostList} fromPage={fromPage} setIsLoading={setIsLoading} hasMore={hasMore} />}

                            {hasMore && fromPage === 'myWall' ? <div>

                                <button
                                    type="submit"
                                    className={`btn btn-primary-complete mt-4 center-horizontal ${isLoad ? "isLogin" : ""
                                        }`}
                                    disabled={isLoad ? true : ''}
                                    onClick={() => {
                                        let pageNumberRes = pageNumber + 1;
                                        setPageNumber(pageNumberRes)
                                    }}
                                >
                                    {isLoad ? (
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    ) :
                                        "Load More"
                                    }
                                </button>
                            </div>
                                : ""}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default MyWall;
